import {BrowserRouter as Router,Navigate,Route,Routes} from 'react-router-dom'
import { Suspense } from 'react';
import { About } from './pages/About';
import Header from './components/Header';
import Home from './pages/Home';
import Loader from './components/Loader';
import Footer from './components/Footer';

import { Services } from './pages/Services';
import Contact from './pages/Contact';

function App() {
  return (
        <Router>
            <Suspense fallback={<Loader/>}>
                  <Header />
                  <Routes>
                          <Route path='/' element={<Home />} />
                          <Route path='/about' element={<About />} />
                          <Route path='/services' element={<Services/>} />
                          <Route path='/contact' element={<Contact/>} />
                          <Route path='*' element={<Navigate replace to='/' />} />
                  </Routes>
                  <Footer />
            </Suspense>
        </Router>
  );
}

export default App;
